import { useForm } from "react-hook-form"
import moment from 'moment';
import { ButtonLoader } from "../Button"
import { Input, Label, TextArea } from "../Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../Modal"
import { useState } from "react"
import { customToast } from "../Toast"
import Send from "../../core/communication"
import { useEffect } from "react"
import { useScope } from "../../container/SelectProjectCompanyContainer";
import "./styles.scss"

const loadActionAndDetails = async (actionId, updateForm, isFromCommunity) => {
  try {
    let response = null;

    if(isFromCommunity) {
      response = await Send.get(`/scale-action-project/5w2h/${actionId}`);
    } else {
      response = await Send.get(`/scale-action-producer/5w2h/${actionId}`);
    }

    if(response && response.id) updateForm(response);
    else throw new Error(response);
  } catch(error) {
    console.log("error", error);
    customToast('Erro ao buscar detalhes da ação.', 'error');
  }
} 

export const Esm5w2hAction = ({ action, handleCloseModal, isFromCommunity = false }) => {
  const [formattedAction, setFormattedAction] = useState('');
  const [actionDetails, setActionDetails] = useState({});
  const { scope } = useScope()

  const { register, getValues, setValue } = useForm({
    mode: "onChange",
  })

  const updateForm = (actionValue) => {
    setActionDetails(actionValue.details)
    setFormattedAction(actionValue);

    if(actionValue?.details) {
      setValue('email', actionValue?.details.email ?? '');
      setValue('instructions', actionValue.details?.instructions ?? '');
      setValue('who', actionValue?.details.who ?? '');
      setValue('why', actionValue?.details.why ?? '');
      setValue('location', actionValue?.details.location ?? '');
      setValue('duration', actionValue?.details.duration ?? '');
      setValue('start_at', moment(actionValue?.details.start_at).format('YYYY-MM-DD') ?? '');
      setValue('finish_at', moment(actionValue?.details.finish_at).format('YYYY-MM-DD') ?? '');
    }
  }

  useEffect(() => {
    if(action.actionId) {
      loadActionAndDetails(action.actionId, updateForm, isFromCommunity);
    }
  }, [action])

  const handleSaveActionDetails = async () => {
    const formattedDetails = {
      ...getValues(),
      [isFromCommunity ? 'scaleActionProject' : 'scaleActionProducer']: formattedAction.id,
      project: scope?.id,
    };

    if(!formattedDetails.email || !formattedDetails.finish_at || !formattedDetails.start_at || !formattedDetails.instructions) {
      customToast('Preencha todas as informações', 'warning');
      return;
    }
    
    try {
      let response = null;

      if(isFromCommunity) {
        response = await Send.post('/scale-action-project/5w2h', formattedDetails)
      } else {
        response = await Send.post('/scale-action-producer/5w2h', formattedDetails)
      }

      if(response?.status === 'ERROR') {
        throw new Error(response.message);
      } 
      customToast('Detalhes salvos.', 'success');
      handleCloseModal()
    } catch(error) {
      console.log("error", error)
      customToast('Erro ao salvar detalhes da ação.', 'error');
    }
  }

  const handleUpdateActionDetails = async () => {
    const formattedDetails = {
      ...getValues(),
      [isFromCommunity ? 'scaleActionProject' : 'scaleActionProducer']: formattedAction.id,
      project: scope?.id,
    }

    if(!formattedDetails.email || !formattedDetails.finish_at || !formattedDetails.start_at || !formattedDetails.instructions) {
      customToast('Preencha todas as informações', 'warning');
      return;
    }
    
    try {
      let response = null;

      if(isFromCommunity) {
        response = await Send.put(`/scale-action-project/5w2h/${actionDetails.id}`, formattedDetails)
      } else {
        response = await Send.put(`/scale-action-producer/5w2h/${actionDetails.id}`, formattedDetails)
      }

      if(response?.status === 'ERROR') {
        throw new Error(response.message);
      }

      customToast(`Detalhes atualizados.`, 'success');
      handleCloseModal()
    } catch(error) {
      customToast(`${response.message}`, 'error');
    }
  }

  return <ModalPanel modalIsOpen={true}>
    <ModalHeader
      closeModal={handleCloseModal}
      title='Detalhes da Ação'
    />
    <ModalBody>
      <div className="complete-esm-modal-5w2h">
        <div className="complete-esm-modal-why-email">
          <Label label="O que? (ação atual)">
            <Input
              name="action"
              value={formattedAction?.action?.title}
              isDisabled
            />
          </Label>
          <Label label="Responsável">
            <Input
              name="email"
              placeholder="Insira aqui o email do responsável"
              register={register("email")}
            />
          </Label>
        </div>
        <div className="complete-esm-modal-flex">
          <div className="complete-esm-modal-flex-who-why">
            <Label label="Onde será realizada? (Localização)">
              <Input
                name="location"
                placeholder="Informe o local onde será realizada a ação"
                register={register("location")}
              />
            </Label>
            <Label label="Como será realizada a ação?">
              <TextArea
                name="instructions"
                placeholder="Informe as instruções para se realizar a ação"
                register={register("instructions")}
              />
            </Label>
            <Label label="Quem realizará a ação?">
              <TextArea
                name="who"
                placeholder="Informe quem realizará a ação"
                register={register("who")}
              />
            </Label>
          </div>
          <div className="complete-esm-modal-flex-who-why">
            <Label label="Em quanto tempo será realizada? (duração)">
              <Input
                name="duration"
                placeholder="Informe a duração da ação"
                register={register("duration")}
              />
            </Label>
            <Label label="Porque realizará a ação?">
              <TextArea
                name="why"
                placeholder="Informe o porquê será realizada a ação"
                register={register("why")}
              />
            </Label>
            <Label label="Data Inicial e Final">
              <Input
                type="date"
                register={register("start_at")}
              />
              <Input
                type="date"
                register={register("finish_at")}
              />
            </Label>
          </div>
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
        <ButtonLoader
          handleClick={formattedAction?.details ? handleUpdateActionDetails : handleSaveActionDetails}
          label={!formattedAction?.details ? "Salvar" : "Alterar"}
          color="orange"
        />
      </ModalFooter>
  </ModalPanel>
}